module.exports = __webpack_public_path__ + "static/media/logo.6e17fd41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/logo.svg
// module id = 160
// module chunks = 0